var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      class: { "view-form-disabled": _vm.type === "view" },
      attrs: { model: _vm.formData, rules: _vm.rules, "label-width": "150px" },
      nativeOn: {
        "!click": function ($event) {
          return _vm.handleReadonlyClick($event)
        },
        "!focusin": function ($event) {
          return _vm.handleReadonlyFocusin($event)
        },
        "!keydown": function ($event) {
          return _vm.handleReadonlyKeydown($event)
        },
      },
    },
    [
      _c("h3", { staticClass: "section-title" }, [_vm._v("基本信息")]),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "客户名称", prop: "customer_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        disabled:
                          _vm.type !== "view" &&
                          (_vm.type !== "add" ||
                            !!_vm.id ||
                            _vm.isApproveOtherDemand),
                        remote: "",
                        "remote-method": _vm.getCompanyList,
                        clearable: "",
                        filterable: "",
                        placeholder: "请输入公司名称",
                      },
                      on: { change: _vm.changeCustomer },
                      model: {
                        value: _vm.formData.customer_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "customer_id", $$v)
                        },
                        expression: "formData.customer_id",
                      },
                    },
                    _vm._l(_vm.companyList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.company_name + "（" + item.id + "）",
                          value: item.id,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "发起人" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.inputName,
                      callback: function ($$v) {
                        _vm.inputName = $$v
                      },
                      expression: "inputName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商机", prop: "opportunity_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择商机后带出",
                        disabled:
                          _vm.type !== "view" &&
                          (_vm.type !== "add" ||
                            !!_vm.id ||
                            _vm.isApproveOtherDemand),
                      },
                      on: { change: _vm.changeOpportunity },
                      model: {
                        value: _vm.formData.opportunity_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "opportunity_id", $$v)
                        },
                        expression: "formData.opportunity_id",
                      },
                    },
                    _vm._l(_vm.opportunityList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "人数" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.type !== "view",
                      readonly: _vm.type === "view",
                      placeholder: "请选择商机后带出",
                    },
                    model: {
                      value: _vm.formData.customers_num,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "customers_num", $$v)
                      },
                      expression: "formData.customers_num",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "单人预算" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.type !== "view",
                      readonly: _vm.type === "view",
                      placeholder: "请选择商机后带出",
                    },
                    model: {
                      value: _vm.formData.per_capita_budget,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "per_capita_budget", $$v)
                      },
                      expression: "formData.per_capita_budget",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "采购金额" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.type !== "view",
                      readonly: _vm.type === "view",
                      placeholder: "请选择商机后带出",
                    },
                    model: {
                      value: _vm.formData.amount,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "amount", $$v)
                      },
                      expression: "formData.amount",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("h3", { staticClass: "section-title" }, [_vm._v("需求项说明")]),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "项目", prop: "project_type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: {
                        disabled:
                          _vm.type !== "view" &&
                          (_vm.type !== "add" ||
                            !!_vm.id ||
                            _vm.isApproveOtherDemand),
                      },
                      on: { change: _vm.changeProject },
                      model: {
                        value: _vm.formData.project_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "project_type", $$v)
                        },
                        expression: "formData.project_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("个性化项目评估（启动会）"),
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("其他个性化需求"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.formData.project_type === "2"
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "任务", prop: "type" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          model: {
                            value: _vm.formData.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "type", $$v)
                            },
                            expression: "formData.type",
                          },
                        },
                        [
                          _vm.shouldShowTaskType("1")
                            ? _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    label: "1",
                                    disabled:
                                      (_vm.type === "add" &&
                                        !!_vm.id &&
                                        _vm.initialTypes.includes("1")) ||
                                      _vm.isApproveOtherDemand,
                                  },
                                },
                                [_vm._v("商城装修")]
                              )
                            : _vm._e(),
                          _vm.shouldShowTaskType("3")
                            ? _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    label: "3",
                                    disabled:
                                      (_vm.type === "add" &&
                                        !!_vm.id &&
                                        _vm.initialTypes.includes("3")) ||
                                      _vm.isApproveOtherDemand,
                                  },
                                },
                                [_vm._v("定制设计及印刷")]
                              )
                            : _vm._e(),
                          _vm.shouldShowTaskType("9")
                            ? _c(
                                "el-checkbox",
                                {
                                  attrs: {
                                    label: "9",
                                    disabled:
                                      _vm.quotationCheckboxDisabled ||
                                      (_vm.type === "add" &&
                                        !!_vm.id &&
                                        _vm.initialTypes.includes("9")) ||
                                      _vm.isApproveOtherDemand,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.quotationCheckboxLabel))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-row",
        { class: { "demand-info-editing": _vm.isEditingTask("demand") } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "需求名称", prop: "project_name" } },
                [
                  _c("el-input", {
                    staticClass: "demand-project-name-input",
                    attrs: {
                      readonly: _vm.isViewTaskDisabled("demand"),
                      maxlength: 50,
                      "show-word-limit": "",
                      placeholder: "请输入需求名称",
                    },
                    model: {
                      value: _vm.formData.project_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "project_name", $$v)
                      },
                      expression: "formData.project_name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showProjectInfoEditButton("demand")
        ? _c("section-edit-actions", {
            attrs: {
              editing: _vm.isEditingTask("demand"),
              loading: _vm.editSaving,
            },
            on: {
              start: function ($event) {
                return _vm.startProjectInfoEdit("demand")
              },
              confirm: _vm.confirmProjectInfoEdit,
              cancel: _vm.cancelProjectInfoEdit,
            },
          })
        : _vm._e(),
      _vm.formData.type.length
        ? _c("h3", { staticClass: "section-title" }, [_vm._v("需求描述")])
        : _vm._e(),
      _vm.visibleTaskTabNames.length || _vm.showKickoffTab
        ? _c(
            "el-tabs",
            {
              ref: "taskTabs",
              staticClass: "task-tabs",
              class: { "task-tabs-sticky": _vm.formData.project_type === "1" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTaskTab,
                callback: function ($$v) {
                  _vm.activeTaskTab = $$v
                },
                expression: "activeTaskTab",
              },
            },
            [
              _vm.showKickoffTab
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "项目启动会信息", name: "kickoff" } },
                    [
                      _c("project-kickoff-tab", {
                        attrs: {
                          "form-data": _vm.formData,
                          type: _vm.type,
                          "project-status": _vm.projectStatus,
                          "edit-saving": _vm.editSaving,
                          "leader-options": _vm.leaderOptions,
                          "quotation-checkbox-disabled":
                            _vm.quotationCheckboxDisabled,
                          "quotation-checkbox-label":
                            _vm.quotationCheckboxLabel,
                          "customer-name": _vm.customerName,
                          "is-editing-task": _vm.isEditingTask,
                          "is-view-task-disabled": _vm.isViewTaskDisabled,
                          "show-project-info-edit-button":
                            _vm.showProjectInfoEditButton,
                          "start-project-info-edit": _vm.startProjectInfoEdit,
                          "confirm-project-info-edit":
                            _vm.confirmProjectInfoEdit,
                          "cancel-project-info-edit": _vm.cancelProjectInfoEdit,
                          "should-show-task-type": _vm.shouldShowTaskType,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.taskTabVisible("1")
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "商城装修", name: "1" } },
                    [
                      _c("mall-decoration-tab", {
                        attrs: {
                          "form-data": _vm.formData,
                          type: _vm.type,
                          "edit-saving": _vm.editSaving,
                          "decoration-person-list": _vm.decorationPersonList,
                          "is-task-form-disabled": _vm.isTaskFormDisabled,
                          "is-editing-task": _vm.isEditingTask,
                          "is-view-task-disabled": _vm.isViewTaskDisabled,
                          "show-project-info-edit-button":
                            _vm.showProjectInfoEditButton,
                          "start-project-info-edit": _vm.startProjectInfoEdit,
                          "confirm-project-info-edit":
                            _vm.confirmProjectInfoEdit,
                          "cancel-project-info-edit": _vm.cancelProjectInfoEdit,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.taskTabVisible("2")
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "投标支持", name: "2" } },
                    [
                      _c("bidding-support-tab", {
                        attrs: {
                          "form-data": _vm.formData,
                          type: _vm.type,
                          "edit-saving": _vm.editSaving,
                          "bid-support-person-list": _vm.bidSupportPersonList,
                          "is-task-form-disabled": _vm.isTaskFormDisabled,
                          "is-editing-task": _vm.isEditingTask,
                          "is-view-task-disabled": _vm.isViewTaskDisabled,
                          "show-project-info-edit-button":
                            _vm.showProjectInfoEditButton,
                          "start-project-info-edit": _vm.startProjectInfoEdit,
                          "confirm-project-info-edit":
                            _vm.confirmProjectInfoEdit,
                          "cancel-project-info-edit": _vm.cancelProjectInfoEdit,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.taskTabVisible("3")
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "定制设计及印刷", name: "3" } },
                    [
                      _c("custom-design-tab", {
                        attrs: {
                          "form-data": _vm.formData,
                          type: _vm.type,
                          "edit-saving": _vm.editSaving,
                          "card-design-person-list": _vm.cardDesignPersonList,
                          "card-type-list": _vm.cardTypeList,
                          "business-type-list": _vm.businessTypeList,
                          "show-card-type-field": _vm.showCardTypeField,
                          "had-initial-design-draft": _vm.hadInitialDesignDraft,
                          "is-task-form-disabled": _vm.isTaskFormDisabled,
                          "is-editing-task": _vm.isEditingTask,
                          "is-view-task-disabled": _vm.isViewTaskDisabled,
                          "show-project-info-edit-button":
                            _vm.showProjectInfoEditButton,
                          "start-project-info-edit": _vm.startProjectInfoEdit,
                          "confirm-project-info-edit":
                            _vm.confirmProjectInfoEdit,
                          "cancel-project-info-edit": _vm.cancelProjectInfoEdit,
                          "change-order-business-type":
                            _vm.changeOrderBusinessType,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.taskTabVisible("9")
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "报价单", name: "9" } },
                    [
                      _c("quotation-tab", {
                        attrs: {
                          "form-data": _vm.formData,
                          type: _vm.type,
                          "project-status": _vm.projectStatus,
                          "quotation-card-type-list": _vm.quotationCardTypeList,
                          "quotation-business-type-list":
                            _vm.quotationBusinessTypeList,
                          "is-task-form-disabled": _vm.isTaskFormDisabled,
                          "is-editing-task": _vm.isEditingTask,
                          "is-view-task-disabled": _vm.isViewTaskDisabled,
                          "change-quotation-business-type":
                            _vm.changeQuotationBusinessType,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _c("bid-opening-delivery-section", {
        attrs: {
          "form-data": _vm.formData,
          type: _vm.type,
          "edit-saving": _vm.editSaving,
          "is-editing-task": _vm.isEditingTask,
          "is-view-task-disabled": _vm.isViewTaskDisabled,
          "show-project-info-edit-button": _vm.showProjectInfoEditButton,
          "start-project-info-edit": _vm.startProjectInfoEdit,
          "confirm-project-info-edit": _vm.confirmProjectInfoEdit,
          "cancel-project-info-edit": _vm.cancelProjectInfoEdit,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }